<template>
  <div class="my-order">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="order-list" v-for="(item,index) in dataList" :key="index">
          <div>
            <span class="list-label">订单编号：</span>
            {{item.orderId}}
          </div>
          <div>
            <span class="list-label">产品名称：</span>
            {{item.productName}}
          </div>
          <div>
            <span class="list-label">订单状态：</span>
            {{item.orderStatusName}}
          </div>
          <div>
            <span class="list-label">订单时间：</span>
            {{item.createTime}}
          </div>
          <van-tag :color="item.tag=='保险'?'#6DEDA2' : '#C3C3FC'">{{item.tag}}</van-tag>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import URLTC from "@/api/apiTC";
export default {
  data() {
    return {
      dataList: [],
      page:1,
      size:10,
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  methods: {
    onLoad(){
      this.getData()
    },
    onRefresh(){
      this.finished=false
      this.loading=true
      this.dataList=[]
      this.page=1
      this.onLoad()
    },
    getData() {
      let that = this
      let data = {
        userid: localStorage.getItem('userid'),
        page: that.page,
        size: that.size
      }
      that.$fetchGet(URLTC.getOrders.url, data).then(res => {
        if (res.data.code == 20000) {
          that.refreshing=false
          that.loading=false
          let list=res.data.data.records
          let total=res.data.data.total
          if(list==null || list.length<=0){
            that.finished=true
            // 加载成功
            return
          }
          if(that.page>1){
            that.dataList=[...that.dataList,...list]
          }else{
            that.dataList=list
          }
          if(that.page * that.size >= total){
            that.finished=true
            return
          }
          if(that.page * that.size < total){
            that.page++
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.my-order {
  height: 100vh;
  background: #fff;
  overflow: scroll;
  font-family: Source Han Sans CN;
  font-weight: 500;
  .order-list {
    position: relative;
    width: 355px;
    height: 135px;
    margin: 10px auto auto;
    background: url("../../assets/publicImg/con-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    overflow: hidden;
    div {
      height: 12px;
      &:not(:first-child) {
        margin-top: 15px;
      }
      &:first-child {
        margin-top: 20px;
      }
    }
    .list-label {
      margin-left: 20px;
      color: #333333;
    }
    .van-tag {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
}
</style>